export default "__VITE_ASSET__CMVZF9A___"